<template>
    <div>
        <el-dialog align-center v-model="state.dialogVisible" :title="title" width="800" draggable @close="handleClose">
            <div class="userAdd_man" v-if="state.isShow === true">
                <el-form ref="ruleForm" label-width="auto" :model="state.form" :rules="rules" class="userFrom">
                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('field.title')" prop="title">
                            <el-input v-model="state.form.title" :placeholder="t('common.pleaseInput')" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveDetail.score')" prop="score">
                            <el-input-number v-model="state.form.score" :min="1" :max="100" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveDetail.taskMaterial')">
                            <el-upload v-model:file-list="state.fileList" :action="state.uploadUrl"
                                :headers="state.headers" list-type="picture-card" :on-success="onSuccess" :limit="3"
                                :accept="acceptTypes" :before-upload="beforeUpload">
                                <el-icon>
                                    <Plus />
                                </el-icon>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveList.startTime')" prop="updated_at">
                            <el-date-picker style="width: 100%；" v-model="state.form.updated_at" type="datetime"
                                value-format="YYYY-MM-DD HH:mm:ss" :placeholder="t('improveList.startTime')" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveList.endTime')" prop="createda_at">
                            <el-date-picker style="width: 100%；" v-model="state.form.createda_at" type="datetime"
                                value-format="YYYY-MM-DD HH:mm:ss" :placeholder="t('improveList.endTime')" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('field.status')" prop="status">
                            <el-switch v-model="state.form.status" :active-value="1" :inactive-value="0"
                                :active-text="t('taskSpecial.published')" :inactive-text="t('taskSpecial.unpublished')" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('taskSpecial.description')" prop="description">
                            <el-input v-model="state.form.description" :placeholder="t('common.pleaseInput')" type="textarea" :rows="5" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('taskSpecial.participants')" prop="description">
                        <el-select :placeholder="t('common.pleaseSelect')" v-model="state.form.userList" filterable multiple clearable  popper-class="custom-header">
                            <template #header>
                                <el-checkbox
                                    v-model="checkAll"
                                    :indeterminate="indeterminate"
                                    @change="handleCheckAll"
                                >
                                    {{ t('common.all') }}
                                </el-checkbox>
                                </template>
                            <el-option
                                v-for="(d, i) in state.userList"
                                :key="i"
                                :label="d.real_name"
                                :value="d.id"
                            />
                        </el-select>
                    </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <!-- 人员角色 -->
            <div v-else class="tree_man">
                <div class="tree_box">
                    <el-tree style="margin-left: -30px" :data="roleOptions" show-checkbox node-key="id"
                        :default-expanded-keys="[1]" :default-checked-keys="[1]" :props="defaultProps" />
                </div>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="state.dialogVisible = false">{{ t('common.cancel') }}</el-button>
                    <el-button type="primary" @click="submit">
                        {{ t('common.confirm') }}
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import {
    onMounted,
    reactive,
    ref,
    nextTick,
    defineEmits,
    defineProps,
    defineExpose,
    toRaw,
} from "vue";
import { getCurrentInstance } from 'vue'
import { ElMessage } from "element-plus";
import { saveApi, detailApi } from "@/api/improve/improve";
import { pageListApi as userListApi } from "@/api/system/personnel";
import { globalConfig } from "@/configs/globalConfig"
import { usePageI18n } from "@/composables/usePageI18n.js";
const indeterminate = ref(false)
const checkAll = ref(false)
const emit = defineEmits([]);
const { proxy } = getCurrentInstance()
const props = defineProps({
    title: {
        type: String,
        default: "人员新增",
    },
    roleOptions: {
        type: Object,
        default: () => { },
    },
    statusOptions: {
        type: Object,
        default: () => { },
    },
    sexOptions: {
        type: Object,
        default: () => { },
    },
    row: {
        type: Object,
        default: () => { },
    }
});

const rules = reactive({
    title: [{ required: true, message: "", trigger: "blur" }],
    description: [{ required: true, message: "", trigger: "blur" }],
    url: [{ required: true, message: "", trigger: "blur" }],
    score: [{ required: true, message: "", trigger: "blur" }],
    status: [{ required: true, message: "", trigger: "blur" }],
});

const applyLabels = () => {
    rules.title[0].message = t('taskSpecial.needTitle');
    rules.description[0].message = t('taskSpecial.needDesc');
    rules.url[0].message = t('taskSpecial.needUpload');
    rules.score[0].message = t('taskSpecial.needScore');
    rules.status[0].message = t('taskSpecial.needStatus');
};
const { t } = usePageI18n(applyLabels);

// const disabledBeforeToday = (time) => {
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);
//     return time.getTime() < today.getTime();
// }

const acceptTypes = ref('image/*')  // 只接受图片类型
// 上传前验证
const beforeUpload = (file) => {
    const isImage = file.type.startsWith('image/')
    if (!isImage) {
        ElMessage.error(t('taskSpecial.imageOnly'))
        return false
    }
    return true
}
const handleCheckAll = ( ) => {
  
  if(indeterminate.value){
      indeterminate.value = false
      state.userList.map(function(element) {
          state.form.userList=[]
      });
  }else{
      indeterminate.value = true
      state.userList.map(function(element) {
          state.form.userList.push(element.id)
      });
  }
console.log(indeterminate.value)
  
}
const defaultProps = {
    children: "children",
    label: "label",
};

const state = reactive({
    userList:[],
    dialogVisible: false,
    isShow: true,
    uploadUrl: globalConfig.uploadUrl,
    headers: {
        "Authorization": "Bearer " + localStorage.getItem("token"),
    },
    fileList: [],
    urlList: [],
    form: {
        "id": 0,
        "title": "",
        "description": "",
        "url": "",
        "duration": 0,
        "score": 0,
        "status": 0,
        "createda_at": null,
        "userList":[]
    }
});

const getDetailInfo = (row = {}) => {
    if (row?.id) {
        const params = JSON.stringify({
            "id": row.id
        })
        detailApi(params).then(res => {
            if (res?.code !== 200) return
            state.form = {
                "id": res.data.id,
                "title": res.data.title,
                "description": res.data.description,
                "url": JSON.parse(res.data.url),
                "duration": 0,
                "score": res.data.score,
                "status": res.data.status,
                "createda_at": res.data.createdAt,
                "updated_at":res.data.updatedAt,
                "userList":res.data.userList,
            }
            state.fileList = JSON.parse(res.data.url)
        })
    } else {
        state.form.id = 0
    }
}

const open = (row) => {
    state.dialogVisible = true;
    getUserList()
    getDetailInfo(row)
};


const getUserList = () => {
    console.log(112)
    const requestParams = {
        "keywords": "",
        "role_id": 0,
        "page": 1,
        "limit": 9999
    }
    userListApi(JSON.stringify(requestParams)).then(res => {
      state.userList = res?.data ?? []
    })
}

const handleClose = () => {
    state.dialogVisible = false;
    state.form = {
        "id": 0,
        "title": "",
        "description": "",
        "url": "",
        "start_time": "",
        "end_time": "",
        "score": 0,
        "status": 0,
        "createda_at": null,
        "updated_at":null,
        "userList":[]
    }
    state.fileList = []
};

// 上传
const upload = ref();
const onSuccess = (response, file, fileList) => {

}

const ruleForm = ref(null)
const submit = () => {
    ruleForm.value.validate((valid) => {
        if (valid) {
            const { user } = JSON.parse(localStorage.getItem("user"));
            const params = JSON.stringify({
                ...toRaw(state.form),
                "url": JSON.stringify(toRaw(state.fileList).map(i => { return { url: i.response?.data || i.url  } })),
                "replied_by": user.users.id,
                "type": 2
            })
            console.log(params)
            saveApi(params).then(res => {
                if (res?.code === 200) {
                    ElMessage.success(t('improveDetail.opSuccess'))
                    state.dialogVisible = false
                    state.form = {
                        "id": 0,
                        "title": "",
                        "description": "",
                        "url": "",
                        "start_time": "",
                        "end_time": "",
                        "score": 0,
                        "status": 0,
                        "createda_at": null,
                        "userList":[]
                    }
                    emit('refresh')
                } else {
                    ElMessage.error(res.msg)
                }
            })
        } else {
            return false;
        }
    });
};

onMounted(() => {
    applyLabels();
    try {
        if (row?.id) {

        } else {
            form.id = 0
        }
    } catch (error) {

    }
});

defineExpose({ open, state });
</script>

<style lang="less" scoped>
.userAdd_man {
    min-height: 500px;
    max-height: 600px;
    overflow: auto;
    padding: 0 30px;
}

.userFrom {
    display: flex;
    flex-wrap: wrap;
    /* 可选，添加网格项之间的间隙 */
    // grid-template-columns: repeat(2, 1fr);
}

.el-form-item {
    margin-bottom: 0;
}

.tree_man {
    padding: 0 30px;
}

.tree_box {
    min-height: 300px;
    max-height: 400px;
    overflow: auto;
}

.user_name {
    border: 1px solid #eee;
    margin-top: 10px;
    min-height: 150px;
}
</style>
